import type { Translations } from "./de";

// English texts. Typed against the German reference: a missing or extra key
// is a compile error (Entscheidung 36: English considered from the start).
export const en: Translations = {
  app: {
    name: "Ortura",
    loading: "Loading …",
    error: "Something went wrong.",
    retry: "Try again",
    backToStart: "Back to start",
  },
  start: {
    title: "Welcome to Ortura",
    subtitle: "Sign in to continue.",
    withGoogle: "Sign in with Google",
    withMicrosoft: "Sign in with Microsoft",
    otherMethods: "Other sign-in methods",
    noAccess: "No access yet? Your administrator will send you an invitation link.",
    devLogin: "Sign in as dev user",
    devHint: "Local mode: sign-in with a test token from the API dev server.",
  },
  callback: {
    working: "Completing sign-in …",
    failed: "Sign-in failed.",
  },
  select: {
    title: "Choose a tenant",
    subtitle: "You are a member of several tenants.",
    create: "Create a new tenant",
  },
  onboarding: {
    title: "Create a tenant",
    intro: "Create your own tenant. It starts as a trial.",
    name: "Name",
    namePlaceholder: "e.g. Example Ltd",
    subdomain: "Short name for the address",
    subdomainHelp:
      "Lowercase letters, digits and hyphens, 3 to 32 characters. Appears in the address: …/t/{{subdomain}}",
    submit: "Create tenant",
    invalidName: "Please enter a name with 2 to 100 characters.",
    invalidSubdomain: "Lowercase letters, digits and hyphens only, 3 to 32 characters.",
  },
  invite: {
    working: "Accepting invitation …",
    missingToken: "The invitation link is incomplete.",
    failed: "The invitation could not be accepted.",
  },
  tenant: {
    notMember: "No access to this tenant",
    notMemberHint: "You are not a member of this tenant, or it does not exist.",
    switch: "Switch tenant",
    status: { trial: "Trial", active: "Active" },
  },
  nav: {
    overview: "Overview",
    members: "Members",
    logout: "Sign out",
    signedInAs: "Signed in as {{email}}",
    language: "Language",
  },
  overview: {
    title: "Overview",
    welcome: "Welcome to the tenant {{name}}.",
    yourRole: "Your role",
    placeholder: "Monitoring views will appear here.",
  },
  members: {
    title: "Members",
    name: "Name",
    email: "Email",
    role: "Role",
    joined: "Joined",
    empty: "No members yet.",
    inviteTitle: "Invite a user",
    inviteIntro:
      "Creates an invitation link. It is valid for 7 days and can be redeemed once. Pass it on to the person yourself.",
    inviteRole: "Role of the invited person",
    inviteSubmit: "Create invitation link",
    inviteLink: "Invitation link",
    copy: "Copy",
    copied: "Copied",
  },
  roles: {
    tenant_admin: "Administrator",
    operator: "Operator",
    viewer: "Viewer",
  },
  languages: { de: "Deutsch", en: "English" },
  errors: {
    unauthenticated: "Your session has expired. Please sign in again.",
    forbidden: "You do not have permission to do this.",
    not_a_member: "No access to this tenant.",
    not_found: "Not found.",
    conflict: "This already exists.",
    limit_reached: "The limit has been reached.",
    invalid_input: "The input is invalid.",
    network_error: "The server cannot be reached.",
  },
};
